"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentBody = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const index_1 = require("../index");
const context_1 = require("../../context");
const DocumentBody = () => {
    const { isHitsAndFiltersLoading, hasError } = (0, context_1.useSearchResultContext)();
    if (hasError) {
        return null;
    }
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: isHitsAndFiltersLoading ? (0, jsx_runtime_1.jsx)(index_1.ContentLoading, {}) : (0, jsx_runtime_1.jsx)(index_1.DocumentContent, {}) });
};
exports.DocumentBody = DocumentBody;
